import allowed from '@/core/constants/allowed-roles.constant'

const index = [
  {
    name: 'Risk Profiling',
    path: '/risk-exposure',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'risk-profiling',
      allowedRoles: [...allowed.risk_profiling.roles],
      breadcrumb: {
        label: 'core.menu.modules.risk-exposure',
        route: 'Risk Profiling',
      },
    },
    component: () =>
      import(
        '@/modules/risk-profiling/containers/risk-profiling-root/risk-profiling-root.container.vue'
      ),
    children: [
      {
        name: 'risk-overview',
        path: 'risk-overview',
        meta: {
          requiresAuth: true,
          module: 'risk-profiling',
          allowedRoles: [...allowed.risk_profiling.roles],
          embedFullViewport: true,
          riskOverviewCompanyAllowlist: true,
          breadcrumb: {
            label: 'core.menu.modules.risk-dashboard',
            route: 'risk-overview',
          },
        },
        component: () =>
          import(
            '@/modules/risk-profiling/containers/risk-overview-embed/risk-overview-embed.container.vue'
          ),
      },
      {
        name: 'risk-profiling-home',
        path: 'risk-profiling',
        meta: {
          breadcrumb: {
            label: 'core.menu.modules.risk-profiling',
            route: 'risk-profiling-home',
          },
        },
        component: () =>
          import(
            '@/modules/risk-profiling/containers/risk-profiling/risk-profiling.container.vue'
          ),
      },
      {
        name: 'risk-profiling-action-register',
        path: 'risk-profiling/action-register',
        meta: {
          breadcrumb: {
            label: 'core.menu.modules.risk-profiling',
            route: 'risk-profiling-home',
          },
        },
        component: () =>
          import(
            '@/modules/risk-profiling/containers/risk-profiling/risk-profiling.container.vue'
          ),
      },
      {
        name: 'risk-profiling-mass-import-risks',
        path: 'risk-profiling/mass-import-risks',
        meta: {
          allowedRoles: [...allowed.risk_profiling.settings],
        },
        component: () =>
          import(
            '@/modules/risk-profiling/containers/risk-profiling-mass-import-risks/risk-profiling-mass-import-risks.container.vue'
          ),
      },
      {
        name: 'risk-profiling-region-risks',
        path: 'risk-profiling/:regionId/risks',
        component: () =>
          import(
            '@/modules/risk-profiling/containers/region-risks/region-risks.container.vue'
          ),
      },
      {
        name: 'risk-profiling-new-risk',
        path: 'risk-profiling/risk',
        component: () =>
          import(
            '@/modules/risk-profiling/containers/risk/risk.container.vue'
          ),
      },
      {
        name: 'risk-profiling-edit-risk',
        path: 'risk-profiling/risk/:riskId',
        redirect: { name: 'risk-profiling-risk-placement' },
        component: () =>
          import(
            '@/modules/risk-profiling/containers/risk/risk.container.vue'
          ),
      },
      {
        name: 'risk-profiling-risk-placement',
        path: 'risk-profiling/risk/:riskId/placement',
        component: () =>
          import('@/modules/risk-profiling/containers/risk/risk.container.vue'),
      },
      {
        name: 'risk-profiling-risk-identification',
        path: 'risk-profiling/risk/:riskId/identification',
        component: () =>
          import('@/modules/risk-profiling/containers/risk/risk.container.vue'),
      },
      {
        name: 'risk-profiling-risk-control-identification',
        path: 'risk-profiling/risk/:riskId/control-identification',
        component: () =>
          import('@/modules/risk-profiling/containers/risk/risk.container.vue'),
      },
      {
        name: 'risk-profiling-risk-critical-control-management',
        path: 'risk-profiling/risk/:riskId/critical-control-management',
        component: () =>
          import('@/modules/risk-profiling/containers/risk/risk.container.vue'),
      },
      {
        name: 'risk-profiling-risk-performance-and-reporting',
        path: 'risk-profiling/risk/:riskId/performance-and-reporting',
        component: () =>
          import('@/modules/risk-profiling/containers/risk/risk.container.vue'),
      },
      {
        name: 'risk-profiling-risk-future-risk',
        path: 'risk-profiling/risk/:riskId/future-risk',
        component: () =>
          import('@/modules/risk-profiling/containers/risk/risk.container.vue'),
      },
      {
        name: 'risk-profiling-risk-residual-analysis',
        path: 'risk-profiling/risk/:riskId/residual-analysis',
        component: () =>
          import('@/modules/risk-profiling/containers/risk/risk.container.vue'),
      },

      // SETTINGS
      {
        name: 'risk-profiling-settings-general',
        path: 'risk-profiling/settings/general',
        component: () =>
          import(
            '@/modules/risk-profiling/containers/risk-profiling-settings/risk-profiling-settings.container.vue'
          ),
      },
      {
        name: 'risk-profiling-settings-matrix',
        path: 'risk-profiling/settings/matrix',
        meta: {
          allowedRoles: [...allowed.risk_profiling.settings],
        },
        component: () =>
          import(
            '@/modules/risk-profiling/containers/risk-profiling-settings/risk-profiling-settings.container.vue'
          ),
      },
      {
        name: 'risk-profiling-create-one-page',
        path: 'risk-profiling/:id/one-page-form/:controlId',
        component: () =>
          import(
            '@/modules/risk-profiling/containers/risk-profiling-one-page-form/risk-profiling-one-page-form.container.vue'
          ),
      },
      {
        name: 'risk-profiling-edit-one-page',
        path: 'risk-profiling/:id/one-page-form/:controlId/one-page-id/:onePageId',
        component: () =>
          import(
            '@/modules/risk-profiling/containers/risk-profiling-one-page-form/risk-profiling-one-page-form.container.vue'
          ),
      },
    ],
  },
]

export default index
